import { Grid2 } from "@mui/material";
import Button from "../../../UI/GeneralPurpose/Button";

const UIText = {
  "es-CL": { label: "Volver" },
  "en-US": { label: "Back" },
};

const BackBtn = () => {
  return (
    <Grid2 container size={{xs:12}} justifyContent="center">
      <Button
        fullWidth
        {...{
          UIText,
          navTo: "/login",
          lg: 3,
          md: 4,
          sm: 6,
          xs: 8,
          variant: "outlined",
        }}
      />
    </Grid2>
  );
};

export default BackBtn;
